import { jsx as _jsx } from "react/jsx-runtime";
import { EMOJI_SET } from './emoji-set.js';
import { getAssetBaseUrl } from '../sounds/sounds.js';
const VARIATION_SELECTOR_REGEX = /[\uFE0E\uFE0F]/g;
function normalizeEmoji(emoji) {
    return emoji.replace(VARIATION_SELECTOR_REGEX, '');
}
function emojiToFilename(emoji) {
    const codePoints = Array.from(emoji).map((char) => {
        const codePoint = char.codePointAt(0);
        if (codePoint == null)
            return '';
        return codePoint.toString(16);
    });
    return `emoji_u${codePoints.join('_')}.svg`;
}
export function getEmojiUrl(emoji) {
    const normalized = normalizeEmoji(emoji);
    return `${getAssetBaseUrl()}emoji/noto/${emojiToFilename(normalized)}`;
}
export function Emoji({ emoji, label, size = '1em', className, style, decorative = false, }) {
    const normalized = normalizeEmoji(emoji);
    if (!EMOJI_SET.includes(normalized)) {
        return (_jsx("span", { "aria-hidden": decorative ? true : undefined, className: className, style: style, children: emoji }));
    }
    const dimension = typeof size === 'number' ? `${size}px` : size;
    const imgStyle = {
        width: dimension,
        height: dimension,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style,
    };
    return (_jsx("img", { src: getEmojiUrl(normalized), alt: decorative ? '' : (label ?? emoji), "aria-hidden": decorative ? true : undefined, className: className, style: imgStyle, loading: "lazy", decoding: "async", draggable: false }));
}
export { EMOJI_SET };
//# sourceMappingURL=index.js.map